import { Magnet } from '@phosphor-icons/react'
import { t } from 'i18next'
import { CommonUtmSelectorDialogUiConfig } from 'src/components/common/utm/CommonUtmSelectorDialog'
import { DEFAULT_UTM_OPTIONS } from 'src/components/common/utm/types'
import { CustomerEligibilityOptions } from 'src/lib/types/common/customerConditions'
import { permissionType } from 'src/lib/utils/constants'

export const allOptions = [
  { label: t('customer_eligibility.all_customers'), value: CustomerEligibilityOptions.ALL_CUSTOMERS },
  { label: t('customer_eligibility.first_time_customers'), value: CustomerEligibilityOptions.FIRST_TIME_CUSTOMERS },
  { label: t('customer_eligibility.specific_customers'), value: CustomerEligibilityOptions.SPECIFIC_CUSTOMERS },
  { label: t('customer_eligibility.specific_pincodes'), value: CustomerEligibilityOptions.SPECIFIC_PINCODES },
  { label: t('customer_eligibility.lifetime_order_count'), value: CustomerEligibilityOptions.LIFETIME_ORDER_COUNT },
  { label: t('customer_eligibility.customer_segment'), value: CustomerEligibilityOptions.CUSTOMER_SEGMENT },
  { label: t('customer_eligibility.utm_parameters'), value: CustomerEligibilityOptions.UTM_PARAMS },
  { label: t('customer_eligibility.order_rate_limit'), value: CustomerEligibilityOptions.ORDER_RATE_LIMIT },
  {
    label: t('customer_eligibility.pincode_rto_risk'),
    value: CustomerEligibilityOptions.PINCODE_RTO_RISK,
    permissionId: permissionType.RTO_NETWORK_SCORE
  },
  {
    label: t('customer_eligibility.customer_rto_risk'),
    value: CustomerEligibilityOptions.CUSTOMER_RTO_RISK,
    permissionId: permissionType.RTO_NETWORK_SCORE
  }
]

export const uiConfig: CommonUtmSelectorDialogUiConfig = {
  title: t('discounts_v2.configure_utms'),
  icon: Magnet,
  description: t('discounts_v2.discount_utm_info'),
  utmOptions: DEFAULT_UTM_OPTIONS
}
